import React, { useState } from "react";
import { UploadSummaryCard } from "./components/UploadSummaryCard";
import { useOutletContext } from 'react-router-dom';
import { ScoutSidebar } from '../dashboard/ScoutSidebar';
import { UploadRosterCard } from "./components/UploadRosterCard";
import { TeamOverviewHeader } from "./components/TeamOverviewHeader";
import { PlayerTable } from "../UncommittedTracker/PlayerTable";

export const TeamAnalysisPage = () => {
  const { activeView } = useOutletContext();
  const [players, setPlayers] = useState([]);
  const [uploadInfo, setUploadInfo] = useState(null);

  const handleParsedPlayers = (parsedPlayers) => {
    setPlayers(parsedPlayers);

    // Calculate upload info from parsed players
    if (parsedPlayers.length > 0) {
      const totalAvg = parsedPlayers.reduce((sum, p) => sum + (parseFloat(p.avg) || 0), 0);
      setUploadInfo({
        count: parsedPlayers.length,
        avg: totalAvg / parsedPlayers.length,
        weakness: "CATCHER", // You can calculate this based on positions
        strengths: "SPEED & PITCHING", // You can calculate this based on stats
      });
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mt-6">
      <div className="lg:col-span-1 ">
        <ScoutSidebar activeView={activeView} />
      </div>
      <section className="lg:col-span-3 w-full max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-4 sm:py-6 md:py-8 border border-slate-700/50 rounded-2xl">
      {/* Top two cards */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4 md:gap-6 mb-4 sm:mb-6">
        <UploadSummaryCard />
        <UploadRosterCard onParsedPlayers={handleParsedPlayers} />
      </div>

      {/* Show content only when CSV data is uploaded */}
      {players.length > 0 ? (
        <>
          {/* Your Team Overview */}
          <div className="bg-slate-800/30 rounded-2xl border border-slate-700/50">
            <TeamOverviewHeader uploadInfo={uploadInfo} />
          </div>

          {/* Player Table */}
          <div className="mt-4 sm:mt-6 overflow-x-auto">
            <PlayerTable data={players} />
          </div>
        </>
      ) : (
        <div className="mt-6 sm:mt-8 text-center py-8 sm:py-12 bg-slate-800/30 rounded-2xl border border-slate-700/50">
          <p className="text-slate-400 text-xs sm:text-sm px-4">
            Upload a CSV file to view your team analysis
          </p>
        </div>
      )}
    </section>
    </div>
  );
};
